<template>
  <div class="d-flex flex-wrap">
    <label class="label"
           v-if="label !== undefined" :for="name"
           :class="labelClass"
    >
      {{label}}
    </label>
    <div class="select" :class="inputClass">
      <select :type="type"
              @input="input"
              :id="name"
              :name="name"
              :class="{'invalid' : error !== undefined}"
              class="input"
              v-model="newValue"
              :disabled="disabled"
      >
        <option disabled hidden selected></option>
        <option v-for="item in myOptions" :value="item">
          {{item}}
        </option>
      </select>
      <div class="select__placeholder" v-if="value === '' && placeholder !== undefined">{{placeholder}}</div>
      <div class="select__img">
        <img src="/img/arrow-down.svg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  import inputMixin from '../../mixins/inputMixin';

  export default {
    name: "InputSelect",
    data() {
      return {
        myOptions: [],
        newValue: '',
        load: false
      }
    },
    props: {
      options: {
        type: Array
      },
    },
    methods: {
      input(e) {
        this.$emit('input', e.target.value);
      },
      addValueEnd(value) {
          let now = new Date();
          let year = now.getFullYear();
          let endOptions = [];
          endOptions.push('н.в.');
          while (year >= parseInt(value)) {
            endOptions.push(year);
            year--;
          }
          this.$parent.$refs.endDate[0].myOptions = endOptions;
        }
    },
    computed: {
      disabled() {
        return this.name === 'end' && this.$parent.data.start === '';
      }
    },
    mounted() {
      if (this.name === 'start') {
        let now = new Date();
        let year = now.getFullYear();
        while (year > 1970) {
          this.myOptions.push(year);
          year--;
        }
      }
      else {
        this.myOptions = this.options;
      }
    },
    beforeUpdate() {
      if (!this.load && this.value !== '') {
        this.load = true;
        this.newValue = this.value;
      }
      if (this.name === 'start') {
        this.addValueEnd(this.value);
      }
    },
    mixins: [inputMixin],
  }
</script>

<style lang="scss">
  .select {
    position: relative;
    margin-bottom: 25px;
    width: 100%;
    &__placeholder {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 12px 20px;
      pointer-events: none;
    }
    &__img {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 36px;
      background-color: #fff;
      pointer-events: none;
    }
  }

  select {
    margin-bottom: 0 !important;
    &:disabled {
      background-color: #eee;
      & + div + .select__img {
        background-color: #eee;
      }
    }
  }
</style>